import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

import * as Types from '../../types.generated'
const defaultOptions = {}
export type ICdPayloadFieldsFragment = {
  id?: any | null
  payloadId: any
  transportedByVehicleId?: string | null
  siteId: any
  orderId: any
  orderItemId: any
  quantity: number
  status: string
  permittedStatuses: Array<string | null>
  hasESignature: boolean
  ticketReference: string
  eta?: any | null
  etaQuality?: string | null
  etaCalculatedAt?: any | null
  cumulativeQuantity: number
  lastUpdatedAt?: any | null
  isReviewed: boolean
  supportsAdditives: boolean
  createdAt?: any | null
  eSignatureMissing: boolean
  deliveredAt?: any | null
  slump?: string | null
  isRetro: boolean
  isRedirect: boolean
  totalNoOfTests: number
  totalNoOfTestsCompleted: number
  timeOnSite: number
  deliveredQuantity?: number | null
  returnedQuantity?: string | null
  payloadEvent?: {
    typedTime?: any | null
    batchStartTime?: any | null
    batchEndTime?: any | null
    departureTime?: any | null
    departureTimeQuality?: string | null
    arrivalTime?: any | null
    pouringStartTime?: any | null
    toPlantTime?: any | null
    washTime?: any | null
  } | null
  waterContent?: {
    waterCementRatioDesign?: string | null
    waterCementRatioActual?: string | null
    designWater?: string | null
    designWaterUOM?: string | null
    actualWater?: string | null
    actualWaterUOM?: string | null
    waterToAdd?: string | null
    waterToAddUOM?: string | null
  } | null
}

export type IGetConcreteDirectPayloadsByOrderIdQueryVariables = Types.Exact<{
  cdOrderId: Types.Scalars['Guid']['input']
}>

export type IGetConcreteDirectPayloadsByOrderIdQuery = {
  concreteDirectPayloads?: {
    data: Array<{
      id?: any | null
      payloadId: any
      transportedByVehicleId?: string | null
      siteId: any
      orderId: any
      orderItemId: any
      quantity: number
      status: string
      permittedStatuses: Array<string | null>
      hasESignature: boolean
      ticketReference: string
      eta?: any | null
      etaQuality?: string | null
      etaCalculatedAt?: any | null
      cumulativeQuantity: number
      lastUpdatedAt?: any | null
      isReviewed: boolean
      supportsAdditives: boolean
      createdAt?: any | null
      eSignatureMissing: boolean
      deliveredAt?: any | null
      slump?: string | null
      isRetro: boolean
      isRedirect: boolean
      totalNoOfTests: number
      totalNoOfTestsCompleted: number
      timeOnSite: number
      deliveredQuantity?: number | null
      returnedQuantity?: string | null
      payloadEvent?: {
        typedTime?: any | null
        batchStartTime?: any | null
        batchEndTime?: any | null
        departureTime?: any | null
        departureTimeQuality?: string | null
        arrivalTime?: any | null
        pouringStartTime?: any | null
        toPlantTime?: any | null
        washTime?: any | null
      } | null
      waterContent?: {
        waterCementRatioDesign?: string | null
        waterCementRatioActual?: string | null
        designWater?: string | null
        designWaterUOM?: string | null
        actualWater?: string | null
        actualWaterUOM?: string | null
        waterToAdd?: string | null
        waterToAddUOM?: string | null
      } | null
    }>
  } | null
}

export type IListenCdPayloadByOrderIdSubscriptionVariables = Types.Exact<{
  cdOrderId: Types.Scalars['Guid']['input']
}>

export type IListenCdPayloadByOrderIdSubscription = {
  concreteDirectPayload?: {
    id?: any | null
    item?: {
      id?: any | null
      payloadId: any
      transportedByVehicleId?: string | null
      siteId: any
      orderId: any
      orderItemId: any
      quantity: number
      status: string
      permittedStatuses: Array<string | null>
      hasESignature: boolean
      ticketReference: string
      eta?: any | null
      etaQuality?: string | null
      etaCalculatedAt?: any | null
      cumulativeQuantity: number
      lastUpdatedAt?: any | null
      isReviewed: boolean
      supportsAdditives: boolean
      createdAt?: any | null
      eSignatureMissing: boolean
      deliveredAt?: any | null
      slump?: string | null
      isRetro: boolean
      isRedirect: boolean
      totalNoOfTests: number
      totalNoOfTestsCompleted: number
      timeOnSite: number
      deliveredQuantity?: number | null
      returnedQuantity?: string | null
      payloadEvent?: {
        typedTime?: any | null
        batchStartTime?: any | null
        batchEndTime?: any | null
        departureTime?: any | null
        departureTimeQuality?: string | null
        arrivalTime?: any | null
        pouringStartTime?: any | null
        toPlantTime?: any | null
        washTime?: any | null
      } | null
      waterContent?: {
        waterCementRatioDesign?: string | null
        waterCementRatioActual?: string | null
        designWater?: string | null
        designWaterUOM?: string | null
        actualWater?: string | null
        actualWaterUOM?: string | null
        waterToAdd?: string | null
        waterToAddUOM?: string | null
      } | null
    } | null
  } | null
}

export const CdPayloadFieldsFragmentDoc = gql`
  fragment CdPayloadFields on ConcreteDirectPayload {
    id
    payloadId
    transportedByVehicleId
    siteId
    orderId
    orderItemId
    quantity
    status
    permittedStatuses
    hasESignature
    ticketReference
    eta
    etaQuality
    etaCalculatedAt
    payloadEvent {
      typedTime
      batchStartTime
      batchEndTime
      departureTime
      departureTimeQuality
      arrivalTime
      pouringStartTime
      toPlantTime
      washTime
    }
    cumulativeQuantity
    lastUpdatedAt
    isReviewed
    supportsAdditives
    createdAt
    eSignatureMissing
    deliveredAt
    slump
    isRetro
    isRedirect
    totalNoOfTests
    totalNoOfTestsCompleted
    timeOnSite
    deliveredQuantity
    returnedQuantity
    waterContent {
      waterCementRatioDesign
      waterCementRatioActual
      designWater
      designWaterUOM
      actualWater
      actualWaterUOM
      waterToAdd
      waterToAddUOM
    }
  }
`
export const GetConcreteDirectPayloadsByOrderIdDocument = gql`
  query GetConcreteDirectPayloadsByOrderId($cdOrderId: Guid!) {
    concreteDirectPayloads(cdOrderId: $cdOrderId, limit: 1000000) {
      data {
        ...CdPayloadFields
      }
    }
  }
  ${CdPayloadFieldsFragmentDoc}
`

/**
 * __useGetConcreteDirectPayloadsByOrderIdQuery__
 *
 * To run a query within a React component, call `useGetConcreteDirectPayloadsByOrderIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetConcreteDirectPayloadsByOrderIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetConcreteDirectPayloadsByOrderIdQuery({
 *   variables: {
 *      cdOrderId: // value for 'cdOrderId'
 *   },
 * });
 */
export function useGetConcreteDirectPayloadsByOrderIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    IGetConcreteDirectPayloadsByOrderIdQuery,
    IGetConcreteDirectPayloadsByOrderIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<
    IGetConcreteDirectPayloadsByOrderIdQuery,
    IGetConcreteDirectPayloadsByOrderIdQueryVariables
  >(GetConcreteDirectPayloadsByOrderIdDocument, options)
}
export function useGetConcreteDirectPayloadsByOrderIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IGetConcreteDirectPayloadsByOrderIdQuery,
    IGetConcreteDirectPayloadsByOrderIdQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    IGetConcreteDirectPayloadsByOrderIdQuery,
    IGetConcreteDirectPayloadsByOrderIdQueryVariables
  >(GetConcreteDirectPayloadsByOrderIdDocument, options)
}
export type GetConcreteDirectPayloadsByOrderIdQueryHookResult = ReturnType<
  typeof useGetConcreteDirectPayloadsByOrderIdQuery
>
export type GetConcreteDirectPayloadsByOrderIdLazyQueryHookResult = ReturnType<
  typeof useGetConcreteDirectPayloadsByOrderIdLazyQuery
>
export type GetConcreteDirectPayloadsByOrderIdQueryResult = Apollo.QueryResult<
  IGetConcreteDirectPayloadsByOrderIdQuery,
  IGetConcreteDirectPayloadsByOrderIdQueryVariables
>
export const ListenCdPayloadByOrderIdDocument = gql`
  subscription ListenCdPayloadByOrderId($cdOrderId: Guid!) {
    concreteDirectPayload(cdOrderId: $cdOrderId) {
      id
      item {
        ...CdPayloadFields
      }
    }
  }
  ${CdPayloadFieldsFragmentDoc}
`

/**
 * __useListenCdPayloadByOrderIdSubscription__
 *
 * To run a query within a React component, call `useListenCdPayloadByOrderIdSubscription` and pass it any options that fit your needs.
 * When your component renders, `useListenCdPayloadByOrderIdSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListenCdPayloadByOrderIdSubscription({
 *   variables: {
 *      cdOrderId: // value for 'cdOrderId'
 *   },
 * });
 */
export function useListenCdPayloadByOrderIdSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    IListenCdPayloadByOrderIdSubscription,
    IListenCdPayloadByOrderIdSubscriptionVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useSubscription<
    IListenCdPayloadByOrderIdSubscription,
    IListenCdPayloadByOrderIdSubscriptionVariables
  >(ListenCdPayloadByOrderIdDocument, options)
}
export type ListenCdPayloadByOrderIdSubscriptionHookResult = ReturnType<
  typeof useListenCdPayloadByOrderIdSubscription
>
export type ListenCdPayloadByOrderIdSubscriptionResult =
  Apollo.SubscriptionResult<IListenCdPayloadByOrderIdSubscription>
